module.exports = __webpack_public_path__ + "img/earnMoney.7cd2648f.svg";